module.exports = __webpack_public_path__ + "media/images/payment/cc-mbs-reta-white-41a573e522c93b15d0f6362124b7771b.png";